module.exports = __webpack_public_path__ + "static/media/11PerformancePhotos.42abc82f.jpeg";